export default "__VITE_ASSET__60f3f46f__"